<template>
  <p>
    For inquiries relating to the scientific content of the workshop, please contact the VIZBI
    chairs:
  </p>
  <Email to="vizbi-contact" :outstanding="true" />
  <p>For inquiries about practical matters (registration, transport, hotels, etc.), please contact
    the Broad Events team:
  </p>
  <p style="margin-left: 2.5em;">
    Tel: +1 617-714-7000<br /><br />
    7 Cambridge Center, Office 7021<br />
    Cambridge MA 02142<br />
    USA
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>

<style scoped>
p:not(:first-child) {
  margin-top: 18px;
}
</style>
